import Survey from './Survey.vue';

export default Survey;
